/**
* Mini Card Testimonials JS
* -----------------------------------------------------------------------------
*
* All the JS for the Mini Card Testimonials component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'mini-card-testimonials',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.mini-card-testimonials' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--mini-card-testimonials' )[0], {
          perPage: 3,
          perMove: 1,
          gap: '32px',
          keyboard: true,
          breakpoints: {
            1024: {
              perPage: 1,
              padding: '64px',
              gap: '16px',
            },
          },
        } );

        splide.mount();

        $( window ).on( 'resize', function() {
          if ( $( component ).find( '.splide' ).hasClass( 'is-overflow' ) ) {
            $( component ).find( '.mini-card-testimonials__navigation' ).removeClass( 'hidden' );
          } else {
            $( component ).find( '.mini-card-testimonials__navigation' ).addClass( 'hidden' );
          }
        } );

        if ( $( component ).find( '.splide' ).hasClass( 'is-overflow' ) ) {
          $( component ).find( '.mini-card-testimonials__navigation' ).removeClass( 'hidden' );
        } else {
          $( component ).find( '.mini-card-testimonials__navigation' ).addClass( 'hidden' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'mini-card-testimonials', COMPONENT );
} )( app );
